import styled, { css } from 'styled-components';

export const HeaderElement = styled.header`
  ${({ theme, ...props }) => {
    return css`
      margin-bottom: ${theme.spacing.base};
      h1,
      h2 {
        @media screen and (max-width: ${theme.breakpoint.sm}) {
          letter-spacing: -0.1rem;
          font-size: ${theme.typography.font_size.title_xl};
        }
      }
      > p {
        display: flex;
        align-items: center;
        gap: 0.125rem;
      }
    `;
  }};
`;

export const ItineraryContent = styled.div<{ ref: any }>`
  ${({ theme, ...props }) => {
    return css`
      margin: ${theme.spacing.md} 0;
      @media screen and (min-width: ${theme.breakpoint.sm}) {
        margin: ${theme.spacing.lg} 0 0 0;
      }
    `;
  }};
`;

export const CtaStickWrapper = styled.div`
  ${({ theme, ...props }) => {
    return css`
      padding: 1rem 0;
      background: ${theme.color.white};
      &.is-pinned {
        padding: 1rem;
        box-shadow: ${theme.box_shadow.default};
        width: auto;
        margin: 0 -2rem;
      }
    `;
  }};
`;
